<template>
  <div id="user-detail-warp">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-layout align-baseline wrap>
        <v-flex :class="grid">
          <p class="display-18 font-weight-medium text-align-center">
            <span class="primary--text">*</span>
            {{ cvPopup.oldPassword }}
          </p>
          <PasswordField @newPassword="handleOldPassword" />
          <v-alert
            v-if="showUpdateError"
            type="error"
            color="primary"
            dense
            class="py-0"
          >
            {{ updateErrorTxt }}
          </v-alert>
        </v-flex>
        <v-flex :class="grid">
          <p class="display-18 font-weight-medium text-align-center">
            <span class="primary--text">*</span>
            {{ cvPopup.newPassword }}
          </p>
          <PasswordField
            :show-recover-link="false"
            @newPassword="handlePasswordUpdate"
          />
        </v-flex>
      </v-layout>
      <v-layout v-show="displaySave" justify-start pa-0 column>
        <v-flex xs12 pa-0 ma-0 text-right>
          <small class="red--text">*שדות חובה</small>
        </v-flex>
      </v-layout>
      <v-layout v-show="displaySave" justify-end pa-0>
        <v-flex xs12 pa-0 text-center>
          <DrBtn
            ref="showAll"
            :action="sendUpdatedDetails"
            type-btn="orange_btn_narrow show-all-selection"
            :loader="inProcess"
            :btn-enabled="!valid"
          >
            {{ cvPopup.saveEdit }}
          </DrBtn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import PasswordField from '@/components/Forms/Form_Fields/PasswordField';
import { UPDATE_PASSWORD } from '@/lib/api.js';

export default {
  components: {
    PasswordField,
  },

  props: {
    displaySave: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
      errorsText: t('titles.errorMessages'),
      grid: 'xl4 lg4 md4 sm12 xs12',
      valid: false,
      lazy: false,
      phone: null,
      updatedEmail: null,
      password: null,
      newPassword: null,
      showUpdateError: false,
      updateErrorTxt: null,

      inProcess: false,
    };
  },

  watch: {},

  methods: {
    handlePasswordUpdate(password) {
      this.newPassword = password;
    },
    handleOldPassword(password) {
      this.password = password;
    },
    showAlert(text) {
      this.$bus.$emit('showDialog', text);

      this.inProcess = false;
      this.resetErrors();
    },
    resetErrors() {
      this.showUpdateError = false;
      this.updateErrorTxt = '';
    },

    validate() {},

    async sendUpdatedDetails() {
      this.inProcess = true;
      if (this.valid) {
        this.showUpdateError = false;
        const data = {
          OldPassword: this.password,
          NewPassword: this.newPassword,
        };

        /**
         * emit @Boolean to spinner indicator gif in CVDetails Component
         */
        this.$nuxt.$emit('inProgress', true);

        return await this.$axios
          .post(`${UPDATE_PASSWORD}`, data)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            this.fetchUser();
            this.$nuxt.$emit('inProgress', false);
            this.showAlert('סיסמה עודכנה בהצלחה');
            return {
              valid: true,
              error: null,
            };
          })
          .catch((e) => {
            const errorType = Object.keys(e)[0];
            this.updateErrorTxt = this.errorsText[errorType];
            this.showUpdateError = true;
            this.$nuxt.$emit('inProgress', false);
            this.inProcess = false;
            return {
              valid: true,
              error: e,
            };
          });
      } else {
        this.inProcess = false;
        this.$nuxt.$emit('inProgress', false);
        this.$emit('disableSendCV');

        return { valid: false, error: null };
      }
    },
    async fetchUser() {
      await this.$auth.fetchUser();
      this.$nuxt.$emit('toggleEditForm');
    },
  },
};
</script>

<style lang="scss" scoped>
#user-detail-warp {
  margin: 0 auto;
}

#user-detail-warp .layout .flex {
  margin: 0;
  padding: 0 10px;
}

.flex p {
  text-align: right;
  margin: 0 10px 5px;
}

@media only screen and (min-width: 920px) {
  .flex p {
    display: block;
  }
}
</style>
